<template>
  <div>
    <div class="card" v-show="!isReady">
      <div class="card-body p-12">
          <div class="d-flex flex-column align-items-start flex-xxl-row">
            <div class="d-flex flex-center flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4" data-bs-toggle="tooltip" data-bs-trigger="hover">
              <span class="fs-2x fw-bolder text-gray-800"> {{$t('store.store_entry')}} # {{  outputStore.numero  }} </span>
            </div>
            <div class="d-flex flex-center flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4" data-bs-toggle="tooltip" data-bs-trigger="hover">
              <span class="fs-2 fw-bolder text-gray-800"> {{$t('store.expeditor')}} : <span style="margin-left: 5px;">{{  outputStore?.from?.name  }}</span></span>
            </div>
          </div>
          <div class="separator separator-dashed my-10"></div>
          <div class="mb-0">
            <div class="table-responsive mb-10">
              <table class="table g-5 gs-0 mb-0 fw-bolder text-gray-700 table-responsive-sm" data-kt-element="items">
                <thead>
                <tr class="border-bottom fs-7 fw-bolder text-gray-700 text-uppercase">
                  <th class="min-w-300px w-350px">{{$t('store.item')}}</th>
                  <th class="min-w-150px w-150px"><strong>{{$t('shop.lot_unite')}}</strong></th>
                  <th class="min-w-100px w-100px"><strong>{{$t('shop.qty_by_lot')}}</strong></th>
                  <th class="min-w-100px w-100px">{{$t('store.qty')}}</th>
                  <th class="min-w-100px w-150px text-end">{{$t('store.conform_quantity')}}</th>
                  <th class="min-w-150px w-250px" > </th>
                </tr>
                </thead>
                <tbody>

                <tr class="border-bottom border-bottom-dashed" data-kt-element="item" v-for="(content, key) in formValidateEntryData.productSaleElements" :key="key">
                  <td class="ps-0">
                    <input type="text" readonly class="form-control form-control-solid mb-2" :value="content.name"/>
                  </td>
                  <td class="ps-0">
                    <input type="text" readonly class="form-control form-control-solid mb-2" :value="content.product_lot_name ? content.product_lot_name : $t('shop.unite')"/>
                  </td>
                  <td class="ps-0">
                    <input type="text" readonly class="form-control form-control-solid mb-2" :value="content.item_number ? content.item_number : '---'"/>
                  </td>
                  <td class="ps-0">
                    <input readonly class="form-control form-control-solid" type="number"  v-model="content.quantity"  />
                  </td>
                  <td class="pt-8 text-end text-nowrap">
                    <span data-kt-element="total">
                      <div class="row fv-row ">
                          <div class="d-flex ">
                              <div class="form-check form-check-custom form-check-solid me-5">
                                  <input  class="form-check-input" type="radio" value="yes"  v-model="content.status"  :name="key.allow" id="allow_guest_reviews_yes" />
                                  <label class="form-check-label" for="allow_guest_reviews_yes">{{$t('store.yes')}}</label>
                              </div>
                              <div class="form-check form-check-custom form-check-solid">
                                  <input class="form-check-input" type="radio" value="no" v-model="content.status" :name="key.allow_guest" id="allow_guest_reviews_no"  />
                                  <label class="form-check-label" for="allow_guest_reviews_no">{{$t('store.no')}}</label>
                              </div>
                          </div>
                      </div>
                    </span>
                  </td>
                  <td class="pe-7"  v-if="content.status === 'no'">
                    <input type="number" class="form-control form-control-solid" min="0" v-model="content.received_quantity"  placeholder="0" />
                  </td>
                </tr>
              </tbody>

              </table>
                <div class="modal-footer">
                  <button type="button"  @click="$goBack" class="btn btn-sm btn-light" >{{ $t('button.close') }}</button>
                  <button v-if="$can('no_validate_entry_update')" @click="validateEntryData" class="btn btn-sm btn-primary fw-bolder">
                    <span class="indicator-label">{{ $t('button.save') }}</span>
                    <span class="indicator-progress">{{  $t('loading') }}
                      <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                  </button>
                </div>
              </div>
          </div>
      </div>
      <!--end::Card body-->
    </div>
    <div class="container-xxl" v-show="isReady">
      <Loader />
    </div>
  </div>
  </template>

  <script>
  import {mapGetters, mapActions} from "vuex";
  import Loader from "@/components/Loader.vue";

  export default {
    name: "Unvalide Entry View",
    components: { Loader },
    data(){
      return {
        productSaleElements: {},
        formValidateEntryData: {
          id: this.$route.params.id,
          entry_id: this.$route.params.entry_id,
          productSaleElements : [],
        },
        outputStore: {},
        store: {},
        isReady: false
      }
    },

    computed: {
      ...mapGetters('products', ['getProductSaleElements']),
    },
  
    async mounted(){
      this.isReady = true

      let response = await this.showOutputStore(this.$route.params.entry_id)
      this.entryStore = response.data.output
      this.formValidateEntryData.productSaleElements = response?.data?.output?.productSaleElements
      let response1 = await this.showStore(this.$route.params.id)
      this.store = response1.data.store
      this.loadAllProductSale()

      this.isReady = false
    },
  
    methods: {
      ...mapActions('store',[
        'showEntrieStore',
        'validateStoreEntry',
        'showStore',
        'showOutputStore'
      ]),

      ...mapActions('products', ['loadAllProductSale']),
  
      async validateEntryData(){
        this.$loading('kt_submit_create_validate_entry')
        let response = {}
  
        try{
          response = await this.validateStoreEntry(this.formValidateEntryData)
          window.toastr['success'](i18n.global.t("notification.shop_validate_entry"))
          let response1 = await this.showStore(this.$route.params.id)
          this.store = response1.data.store
          this.$router.push({ name: 'store-details-entries' })
          this.$stopLoading('kt_submit_create_validate_entry')
          return true
        }catch(err){
          this.$stopLoading('kt_submit_create_validate_entry')
          window.toastr['error'](err.data.message)
          this.isLoading = false;
        }
      },
    }
  }
  </script>
  
  <style scoped>
  
  </style>